import axios from "http/customAxios";

interface GetAriSnapshotRequest {
  hotelTicker: string;
  queryInstant: string;
  ariDaysRange: {
    startDate: string;
    endDate: string;
  };
  asDownloadable: boolean;
}

interface GetAriSnapshotResponse {
  url: string;
}

export async function getAriSnapshot(
  request: GetAriSnapshotRequest
): Promise<GetAriSnapshotResponse> {
  const url = `${window?.CONFIG?.metaSearchApiGateway}/ari/values`;
  try {
    const response = await axios.post(url, request, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (e) {
    //@ts-ignore
    throw e.response.data;
  }
}
